import { Component } from '@angular/core';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, shareReplay } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';

@Component({
    selector: 'app-help-widget',
    templateUrl: './help-widget.component.html',
    styleUrls: ['./help-widget.component.scss'],
    standalone: false
})
export class HelpWidgetComponent  {
  constructor(public contentService: ContentService,protected config: OccConfig) {}
  helpNode: Observable<any> = this.contentService.getBannerNode().pipe(shareReplay(1))
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.url;
  }
}
